import { createSlice, PayloadAction } from '@reduxjs/toolkit'

declare global {
    interface Window {
        PrimaryThemeColour?: string
        SecondaryThemeColour?: string
        WebsiteDescription?: string
        ServesCuisine?: string
        StoreIconPath?: string
    }
}

export interface Theme {
    primaryThemeColour: string
    secondaryThemeColour: string
    websiteDescription: string
    servesCuisine: string
    storeIconPath: string
}

interface ThemeState {
    theme: Theme | null
    isLoaded: boolean
}

const initialState: ThemeState = {
    theme: null,
    isLoaded: false,
}

export const theamSlice = createSlice({
    name: 'theam',
    initialState,
    reducers: {
        setTheme: (state, action: PayloadAction<Theme>) => {
            state.theme = action.payload
            state.isLoaded = true
        },
        clearTheme: (state) => {
            state.theme = null
            state.isLoaded = false
        },
        loadThemeFromWindow: (state) => {
            if (window.PrimaryThemeColour) {
                state.theme = {
                    primaryThemeColour: window.PrimaryThemeColour ?? '',
                    secondaryThemeColour: window.SecondaryThemeColour ?? '',
                    websiteDescription: window.WebsiteDescription ?? '',
                    servesCuisine: window.ServesCuisine ?? '',
                    storeIconPath: window.StoreIconPath ?? '',
                }
                state.isLoaded = true
            } else {
                console.warn('Theme data is not available on window')
            }
        },
    },
})

export const { setTheme, clearTheme, loadThemeFromWindow } = theamSlice.actions
export const selectTheme = (state: { theam: ThemeState }) => state.theam.theme
export const selectIsThemeLoaded = (state: { theam: ThemeState }) => state.theam.isLoaded
export default theamSlice.reducer
